import { updateField } from "../../../api/fieldsApi";

export const POSITION_LIST_FIELD_DEFS = [
  { suffix: "slug", label: "Slug", fieldType: "text" },
  { suffix: "category", label: "Category", fieldType: "text" },
  { suffix: "title", label: "Title", fieldType: "text" },
  { suffix: "description", label: "Short description", fieldType: "textarea" },
  { suffix: "location", label: "Location", fieldType: "text" },
  { suffix: "type", label: "Employment type", fieldType: "text" },
];

export const POSITION_RESPONSIBILITY_FIELD_DEFS = Array.from(
  { length: 10 },
  (_, i) => ({
    suffix: `responsibility_${i}`,
    label: `Responsibility ${i + 1}`,
    fieldType: "text",
  })
);

export const POSITION_DETAIL_FIELD_DEFS = [
  { suffix: "intro", label: "Intro", fieldType: "textarea" },
  { suffix: "role", label: "The role", fieldType: "textarea" },
  {
    suffix: "responsibilities_intro",
    label: "Responsibilities intro",
    fieldType: "textarea",
  },
  ...POSITION_RESPONSIBILITY_FIELD_DEFS,
  { suffix: "qualifications", label: "Qualifications", fieldType: "textarea" },
];

export const POSITION_FIELD_DEFS = [
  ...POSITION_LIST_FIELD_DEFS,
  ...POSITION_DETAIL_FIELD_DEFS,
];

export const EMPTY_POSITION_FORM = POSITION_FIELD_DEFS.reduce((acc, def) => {
  acc[def.suffix] = "";
  return acc;
}, {});

export function groupPositionFields(fields) {
  const byIndex = new Map();

  fields.forEach((field) => {
    const match = /^position_(\d+)_(.+)$/.exec(field.key || "");
    if (!match) return;
    const index = Number(match[1]);
    const suffix = match[2];
    if (!byIndex.has(index)) byIndex.set(index, {});
    byIndex.get(index)[suffix] = field;
  });

  return [...byIndex.entries()]
    .sort(([a], [b]) => a - b)
    .map(([index, fieldMap]) => ({ index, fields: fieldMap }));
}

export function groupFilterFields(fields) {
  return fields
    .filter((f) => /^filter_\d+$/.test(f.key || ""))
    .sort(
      (a, b) =>
        Number(a.key.split("_")[1]) - Number(b.key.split("_")[1])
    );
}

export function positionGroupToForm(positionGroup) {
  const form = { ...EMPTY_POSITION_FORM };
  POSITION_FIELD_DEFS.forEach((def) => {
    const field = positionGroup.fields[def.suffix];
    if (field) form[def.suffix] = field.value ?? "";
  });
  return form;
}

export function getPositionTitle(positionGroup, values = {}) {
  const titleField = positionGroup.fields.title;
  return (
    (titleField && values[titleField.id]) ||
    titleField?.value ||
    positionGroup.fields.slug?.value ||
    `Position ${positionGroup.index}`
  );
}

export async function syncPositionCount(sectionId, fields, positionGroups) {
  const countField = fields.find((f) => f.key === "position_count");
  if (!countField) return;

  const nextCount = String(positionGroups.length);
  if (String(countField.value ?? "") === nextCount) return;

  await updateField(countField.id, {
    label: countField.label,
    fieldType: countField.fieldType,
    isRequired: countField.isRequired,
    isPublished: countField.isPublished,
    sortOrder: countField.sortOrder,
    value: nextCount,
  });
}

export function slugifyTitle(title) {
  return String(title || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}
